import { View } from 'foundations-components/components/View';
import { VideoPlayerWithControls } from '../../features/video';
import LessonInfoTabs from '../LessonPage/LessonInfoTabs';
import { LearningContentContainer } from '../../features/learningContent';
import LearningPageMainSection from '../../containers/TrackPage/LearningPageMainSection';
import { InteractiveEducationLayout } from '../../features/interactiveEducation/components/InteractiveEducationLayout';
import { extractVideoMetadata, buildInteractiveContentTrackingProps } from '../../features/interactiveEducation/utils/contentUtils';

// @ts-expect-error - academy-shared-js is a JavaScript package without type definitions

import { useInteractiveEducationProps } from '../../features/interactiveEducation/hooks/useInteractiveEducationProps';
import { useInteractiveEducation } from '../../features/interactiveEducation/hooks/useInteractiveEducation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TrackContentWithInteractiveEducation = ({
  contentId,
  lesson,
  track,
  onAdvanceContent,
  videoContent
}) => {
  const contentIdNumber = Number(contentId);
  const lessonId = Number(lesson.id);
  const trackId = Number(track.id);
  const language = track.language || 'en';
  const lessonName = lesson.name;
  const trackName = track.name;
  const isPubliclyVisible = lesson.visibility === 'PUBLIC';
  const {
    contentPortalId,
    professorId,
    videoId: extractedVideoId
  } = extractVideoMetadata(videoContent);

  // Ensure videoId is a number or undefined (handle string/NaN cases)
  const videoId = extractedVideoId != null && !isNaN(Number(extractedVideoId)) ? Number(extractedVideoId) : undefined;
  const trackingPropsSource = Object.assign({}, videoContent, {
    hsSoftwareFilters: track.hsSoftwareFilters,
    subCategories: track.subCategories,
    useCases: lesson.useCases
  });
  const interactiveContentTrackingProps = buildInteractiveContentTrackingProps(trackingPropsSource, 'TRACK', contentIdNumber, professorId);
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation,
    interactiveEducationEnabled,
    enableAdaptToIndustry
  } = useInteractiveEducation({
    videoId,
    creatorRegion: videoContent === null || videoContent === void 0 ? void 0 : videoContent.hublet,
    contentPortalId,
    interactiveContentTrackingProps
  });
  const interactiveEducationProps = useInteractiveEducationProps({
    primaryContentId: lessonId,
    contentType: 'LESSON',
    language,
    lessonContentId: contentIdNumber,
    interactiveContentTrackingProps
  });
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    contentId: contentIdNumber,
    language: language,
    lessonId: lessonId,
    trackId: trackId,
    children: [/*#__PURE__*/_jsx(LearningPageMainSection, {
      children: /*#__PURE__*/_jsx(View, {
        "data-contentid": contentId,
        "data-test-id": "stored-content-container",
        children: /*#__PURE__*/_jsx(InteractiveEducationLayout, {
          contentPortalId: contentPortalId,
          contentType: "LESSON",
          displayInteractiveEducation: displayInteractiveEducation,
          enableAdaptToIndustry: enableAdaptToIndustry,
          interactiveContentTrackingProps: interactiveContentTrackingProps,
          interactiveEducationEnabled: interactiveEducationEnabled,
          interactiveEducationProps: interactiveEducationProps,
          language: language,
          lessonContentId: contentIdNumber,
          primaryContentId: lessonId,
          videoId: videoId,
          videoTitle: videoContent.name,
          children: /*#__PURE__*/_jsx(VideoPlayerWithControls, {
            additionalTracking: interactiveContentTrackingProps,
            contentId: contentId,
            displayInteractiveEducation: displayInteractiveEducation,
            enableAdaptToIndustry: enableAdaptToIndustry,
            enableQuizMe: true,
            enableSummarize: true,
            handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
            interactiveEducationEnabled: interactiveEducationEnabled,
            isPubliclyVisible: isPubliclyVisible,
            language: language,
            lessonId: String(lessonId),
            lessonName: lessonName,
            onFinish: onAdvanceContent,
            trackId: trackId,
            trackName: trackName
          })
        })
      })
    }), /*#__PURE__*/_jsx(LessonInfoTabs, {
      contentId: contentId,
      fullLesson: lesson,
      trackId: trackId
    })]
  });
};
export default TrackContentWithInteractiveEducation;